<template>
  <!-- OUTIL DE RECHERCHE -->
  <div>
    <div :class="`input-group input-group-${searcherInputColor}`">
      <input
        v-model="searcherContent"
        type="text"
        name="recherche"
        class="form-control"
        :placeholder="searcherText"
        :title="searcherText"
        @keypress="searchFormKeyPress($event)"
      />
      <button
        :class="searcherButtonClass"
        type="button"
        aria-label="Lancer la recherche"
        title="Lancer la recherche"
        @click="search($event)"
      >
        <IneaIcone
          name="dgfipicon-rechercher"
          :color="searcherIconColor"
          class="unclickable"
          background="transparent"
          size="xs"
          role="button"
          aria-expanded="false"
        />
      </button>
    </div>
  </div>
</template>

<script>
import IneaIcone from "@clir/IneaIcone/IneaIcone";
export default {
  name: "SearchForm",
  data() {
    return { searcherContent: "" };
  },
  props: {
    searchConfig: { type: Object, default: () => {} }
  },
  computed: {
    searcherButtonClass() {
      return this.prefixStringKey(this.searchConfig, "searcherClass", {
        prefix: "btn btn-small border ",
        defaut: "btn btn-gray-100 btn-small border "
      });
    },
    searcherText() {
      return this.getKey(this.searchConfig, "searcherText", "");
    },
    searcherInputColor() {
      return this.getKey(this.searchConfig, "searcherInputColor", "");
    },
    searcherIconColor() {
      return this.getKey(this.searchConfig, "searcherIconColor", "");
    }
  },
  methods: {
    searchFormKeyPress(event) {
      if (event.keyCode === 13) {
        this.search(event);
      }
    },
    search() {
      event.preventDefault();
      this.$emit("search", this.searcherContent);
      this.searcherContent = "";
    }
  },
  components: {
    IneaIcone
  }
};
</script>